import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from "react-bootstrap/Carousel";

function ArticalesCarousel() {
  return (
    <Carousel variant="dark">
      <Carousel.Item>
        <img
          className="mx-auto"
          src="images/image_2023_03_01T01_02_33_924Z.png"
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="mx-auto"
          src="images/image_2023_03_01T01_02_33_924Z.png"
          alt="Second slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="mx-auto"
          src="images/image_2023_03_01T01_02_33_924Z.png"
          alt="Third slide"
        />
      </Carousel.Item>
    </Carousel>
  );
}

export default ArticalesCarousel;
